/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  palette: {
    light: {
      text: {
        primary: "#2d3748",
        secondary: "#575f6d",
        disabled: "#2d374861",
        _states: {
          hover: "#2d37480a",
          selected: "#2d374814",
          focus: "#2d37481f",
          focusVisible: "#2d37484d",
        },
      },
      primary: {
        main: "#1b4187",
        dark: "#1b4187",
        light: "#265da6",
        contrastText: "#ffffff",
        _states: {
          hover: "#1b41870a",
          selected: "#1b418714",
          focus: "#1b41871f",
          focusVisible: "#1b41874d",
          outlinedBorder: "#1b418780",
        },
      },
      secondary: {
        main: "#37474f",
        dark: "#263238",
        light: "#455a64",
        contrastText: "#ffffff",
        _states: {
          hover: "#455a640a",
          selected: "#455a6414",
          focus: "#455a641f",
          focusVisible: "#455a644d",
          outlinedBorder: "#9c27b080",
        },
      },
      action: {
        active: "#0000008a",
        hover: "#0000000a",
        selected: "#00000014",
        disabledBackground: "#0000001f",
        focus: "#0000001f",
        disabled: "#00000042",
      },
      error: {
        main: "#d32f2f",
        dark: "#c62828",
        light: "#ef5350",
        _states: {
          hover: "#d32f2f0a",
          selected: "#d32f2f14",
          focusVisible: "#d32f2f4d",
          outlinedBorder: "#d32f2f80",
        },
        contrastText: "#ffffff",
      },
      warning: {
        main: "#ef6c00",
        dark: "#e65100",
        light: "#ff9800",
        _states: {
          hover: "#ef6c000a",
          selected: "#ef6c0014",
          focusVisible: "#ef6c004d",
          outlinedBorder: "#ef6c0080",
        },
        contrastText: "#ffffff",
      },
      info: {
        main: "#347fcb",
        dark: "#2c6eb8",
        light: "#3a8cd8",
        _states: {
          hover: "#347fcb0a",
          selected: "#347fcb14",
          focusVisible: "#347fcb4d",
          outlinedBorder: "#347fcb80",
        },
        contrastText: "#ffffff",
      },
      success: {
        main: "#2e7d32",
        dark: "#1b5e20",
        light: "#4caf50",
        contrastText: "#ffffff",
        _states: {
          hover: "#2e7d320a",
          selected: "#2e7d3214",
          focusVisible: "#2e7d324d",
          outlinedBorder: "#2e7d3280",
        },
      },
      common: {
        white: {
          _states: {
            main: "#ffffff",
            hover: "#ffffff0a",
            selected: "#ffffff14",
            focus: "#ffffff1f",
            focusVisible: "#ffffff4d",
            outlinedBorder: "#ffffff80",
          },
        },
        black: {
          _states: {
            main: "#000000",
            hover: "#0000000a",
            selected: "#00000014",
            focus: "#0000001f",
            focusVisible: "#0000004d",
            outlinedBorder: "#00000080",
          },
        },
      },
      background: {
        default: "#f9fdff",
        paper: "#ffffff",
      },
      _components: {
        paper: {
          "elevation-0": "#ffffff",
          "elevation-1": "#ffffff",
          "elevation-2": "#ffffff",
          "elevation-3": "#ffffff",
          "elevation-4": "#ffffff",
          "elevation-5": "#ffffff",
          "elevation-6": "#ffffff",
          "elevation-7": "#ffffff",
          "elevation-8": "#ffffff",
          "elevation-9": "#ffffff",
          "elevation-10": "#ffffff",
          "elevation-11": "#ffffff",
          "elevation-12": "#ffffff",
          "elevation-13": "#ffffff",
          "elevation-14": "#ffffff",
          "elevation-15": "#ffffff",
          "elevation-16": "#ffffff",
          "elevation-17": "#ffffff",
          "elevation-18": "#ffffff",
          "elevation-19": "#ffffff",
          "elevation-20": "#ffffff",
          "elevation-21": "#ffffff",
          "elevation-22": "#ffffff",
          "elevation-23": "#ffffff",
          "elevation-24": "#ffffff",
          outlineBorder: "#0000001f",
        },
        rating: {
          enabledBorder: "#0000003b",
          activeFill: "#ffb400",
        },
        avatar: {
          fill: "#bdbdbd",
        },
        input: {
          standard: {
            enabledBorder: "#0000006b",
            hoverBorder: "#000000",
          },
          filled: {
            enabledFill: "#0000000f",
            hoverFill: "#00000017",
          },
          outlined: {
            enabledBorder: "#0000003b",
            hoverBorder: "#000000",
          },
        },
        switch: {
          knobFillEnabled: "#fafafa",
          slideFill: "#000000",
          knowFillDisabled: "#f5f5f5",
        },
        chip: {
          defaultCloseFill: "#000000",
          defaultHoverFill: "#0000001f",
          defaultEnabledBorder: "#bdbdbd",
          defaultFocusFill: "#00000033",
        },
        tooltip: {
          fill: "#616161e6",
        },
        backdrop: {
          fill: "#00000080",
        },
        appBar: {
          defaultFill: "#f5f5f5",
        },
        breadcrumbs: {
          collapseFill: "#f5f5f5",
        },
        alert: {
          error: {
            color: "#5f2120",
            background: "#fdeded",
          },
          warning: {
            color: "#663c00",
            background: "#fff4e5",
          },
          info: {
            color: "#014361",
            background: "#e5f6fd",
          },
          success: {
            color: "#1e4620",
            background: "#edf7ed",
          },
        },
        stepper: {
          connector: "#bdbdbd",
        },
        snackbar: {
          fill: "#323232",
        },
        table: {
          border: "#e0e0e0",
        },
      },
      divider: "#0000001f",
      _native: {
        "scrollbar-bg": "#eeeeee",
      },
      onPrimary: {
        _states: {
          focus: "#ffffff1f",
          selected: "#ffffff14",
          hover: "#ffffff0a",
          focusVisible: "#ffffff4d",
          outlinedBorder: "#ffffff80",
        },
        light: "#ffffff",
        main: "#ffffff",
        dark: "#ffffff",
        contrastText: "#2d3748",
      },
      menu: {
        background: {
          default: "#1b4187",
          selected: "#ffffff",
          hovered: "#0000000a",
        },
        text: {
          default: "#ffffff",
          selected: "#2d3748",
        },
      },
    },
    dark: {
      text: {
        primary: "#ffffff",
        secondary: "#ffffffb3",
        disabled: "#ffffff61",
        _states: {
          hover: "#ffffff14",
          selected: "#ffffff29",
          focus: "#ffffff1f",
          focusVisible: "#ffffff4d",
        },
      },
      primary: {
        main: "#92c4eb",
        dark: "#6bade2",
        light: "#e3f0fa",
        contrastText: "#2d3748",
        _states: {
          hover: "#92c4eb14",
          selected: "#92c4eb29",
          focus: "#92c4eb1f",
          focusVisible: "#92c4eb4d",
          outlinedBorder: "#92c4eb80",
        },
      },
      secondary: {
        main: "#eceff1",
        dark: "#cfd8dc",
        light: "#eceff1",
        contrastText: "#2d3748de",
        _states: {
          hover: "#b0bec514",
          selected: "#b0bec529",
          focus: "#b0bec51f",
          focusVisible: "#b0bec54d",
          outlinedBorder: "#ce93d880",
        },
      },
      action: {
        active: "#ffffff",
        hover: "#ffffff14",
        selected: "#ffffff29",
        disabledBackground: "#ffffff1f",
        focus: "#ffffff1f",
        disabled: "#ffffff4d",
      },
      error: {
        main: "#e57373",
        dark: "#ef5350",
        light: "#ef9a9a",
        _states: {
          hover: "#f4433614",
          selected: "#f4433629",
          focusVisible: "#f443364d",
          outlinedBorder: "#f4433680",
        },
        contrastText: "#ffffff",
      },
      warning: {
        main: "#ffb74d",
        dark: "#ffa726",
        light: "#ffcc80",
        _states: {
          hover: "#ffa72614",
          selected: "#ffa72629",
          focusVisible: "#ffa7264d",
          outlinedBorder: "#ffa72680",
        },
        contrastText: "#000000de",
      },
      info: {
        main: "#6bade2",
        dark: "#509cdd",
        light: "#92c4eb",
        _states: {
          hover: "#92c4eb14",
          selected: "#92c4eb29",
          focusVisible: "#92c4eb4d",
          outlinedBorder: "#92c4eb80",
        },
        contrastText: "#2d3748de",
      },
      success: {
        main: "#81c784",
        dark: "#66bb6a",
        light: "#a5d6a7",
        contrastText: "#000000de",
        _states: {
          hover: "#66bb6a14",
          selected: "#66bb6a29",
          focusVisible: "#66bb6a4d",
          outlinedBorder: "#66bb6a80",
        },
      },
      common: {
        white: {
          _states: {
            main: "#ffffff",
            hover: "#ffffff14",
            selected: "#ffffff29",
            focus: "#ffffff1f",
            focusVisible: "#ffffff4d",
            outlinedBorder: "#ffffff80",
          },
        },
        black: {
          _states: {
            main: "#000000",
            hover: "#00000014",
            selected: "#00000029",
            focus: "#0000001f",
            focusVisible: "#0000004d",
            outlinedBorder: "#00000080",
          },
        },
      },
      background: {
        default: "#121212",
        paper: "#1e1e1e",
      },
      _components: {
        paper: {
          "elevation-0": "#121212",
          "elevation-1": "#1e1e1e",
          "elevation-2": "#232323",
          "elevation-3": "#252525",
          "elevation-4": "#272727",
          "elevation-5": "#2a2a2a",
          "elevation-6": "#2c2c2c",
          "elevation-7": "#2c2c2c",
          "elevation-8": "#2e2e2e",
          "elevation-9": "#2e2e2e",
          "elevation-10": "#313131",
          "elevation-11": "#313131",
          "elevation-12": "#333333",
          "elevation-13": "#333333",
          "elevation-14": "#333333",
          "elevation-15": "#333333",
          "elevation-16": "#363636",
          "elevation-17": "#363636",
          "elevation-18": "#363636",
          "elevation-19": "#363636",
          "elevation-20": "#383838",
          "elevation-21": "#383838",
          "elevation-22": "#383838",
          "elevation-23": "#383838",
          "elevation-24": "#383838",
          outlineBorder: "#ffffff1f",
        },
        rating: {
          enabledBorder: "#ffffff3b",
          activeFill: "#ffb400",
        },
        avatar: {
          fill: "#757575",
        },
        input: {
          standard: {
            enabledBorder: "#ffffff6b",
            hoverBorder: "#ffffff",
          },
          filled: {
            enabledFill: "#ffffff17",
            hoverFill: "#ffffff1f",
          },
          outlined: {
            enabledBorder: "#ffffff3b",
            hoverBorder: "#ffffff",
          },
        },
        switch: {
          knobFillEnabled: "#e0e0e0",
          slideFill: "#ffffff61",
          knowFillDisabled: "#757575",
        },
        chip: {
          defaultCloseFill: "#ffffff",
          defaultHoverFill: "#ffffff1f",
          defaultEnabledBorder: "#616161",
          defaultFocusFill: "#ffffff33",
        },
        tooltip: {
          fill: "#616161e6",
        },
        backdrop: {
          fill: "#00000080",
        },
        appBar: {
          defaultFill: "#272727",
        },
        breadcrumbs: {
          collapseFill: "#757575",
        },
        alert: {
          error: {
            color: "#f4c7c7",
            background: "#160b0b",
          },
          warning: {
            color: "#ffe2b7",
            background: "#191207",
          },
          info: {
            color: "#b8e7fb",
            background: "#071318",
          },
          success: {
            color: "#cce8cd",
            background: "#0c130d",
          },
        },
        stepper: {
          connector: "#757575",
        },
        snackbar: {
          fill: "#2c2c2c",
        },
        table: {
          border: "#515151",
        },
      },
      divider: "#ffffff1f",
      _native: {
        "scrollbar-bg": "#616161",
      },
      onPrimary: {
        _states: {
          focus: "#2d37481f",
          selected: "#2d374829",
          hover: "#2d374814",
          focusVisible: "#2d37484d",
          outlinedBorder: "#2d374880",
        },
        light: "#ffffff",
        main: "#ffffff",
        dark: "#ffffff",
        contrastText: "#2d3748",
      },
      menu: {
        background: {
          default: "#1e1e1e",
          selected: "#92c4eb",
          hovered: "#ffffff14",
        },
        text: {
          default: "#ffffff",
          selected: "#2d3748",
        },
      },
    },
  },
  colors: {
    light: {
      grey: {
        "50": "#fafafa",
        "100": "#f5f5f5",
        "200": "#eeeeee",
        "300": "#e0e0e0",
        "400": "#bdbdbd",
        "500": "#9e9e9e",
        "600": "#757575",
        "700": "#616161",
        "800": "#424242",
        "900": "#212121",
        A100: "#f5f5f5",
        A200: "#eeeeee",
        A400: "#bdbdbd",
        A700: "#616161",
      },
      blue: {
        "50": "#e3f2fd",
        "100": "#bbdefb",
        "200": "#90caf9",
        "300": "#64b5f6",
        "400": "#42a5f5",
        "500": "#2196f3",
        "600": "#1e88e5",
        "700": "#1976d2",
        "800": "#1565c0",
        "900": "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff",
      },
      purple: {
        "50": "#f3e5f5",
        "100": "#e1bee7",
        "200": "#ce93d8",
        "300": "#ba68c8",
        "400": "#ab47bc",
        "500": "#9c27b0",
        "600": "#8e24aa",
        "700": "#7b1fa2",
        "800": "#6a1b9a",
        "900": "#4a148c",
        A100: "#ea80fc",
        A200: "#e040fb",
        A400: "#d500f9",
        A700: "#aa00ff",
      },
      red: {
        "50": "#feebee",
        "100": "#fecdd2",
        "200": "#ef9a9a",
        "300": "#e57373",
        "400": "#ef5350",
        "500": "#f44336",
        "600": "#e53935",
        "700": "#d32f2f",
        "800": "#c62828",
        "900": "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000",
      },
      green: {
        "50": "#e8f5e9",
        "100": "#c8e6c9",
        "200": "#a5d6a7",
        "300": "#81c784",
        "400": "#66bb6a",
        "500": "#4caf50",
        "600": "#43a047",
        "700": "#388e3c",
        "800": "#2e7d32",
        "900": "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853",
      },
      orange: {
        "50": "#fff3e0",
        "100": "#ffe0b2",
        "200": "#ffcc80",
        "300": "#ffb74d",
        "400": "#ffa726",
        "500": "#ff9800",
        "600": "#fb8c00",
        "700": "#f57c00",
        "800": "#ef6c00",
        "900": "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00",
      },
      lightBlue: {
        "50": "#e1f5fe",
        "100": "#b3e5fc",
        "200": "#81d4fa",
        "300": "#4fc3f7",
        "400": "#29b6f6",
        "500": "#03a9f4",
        "600": "#039be5",
        "700": "#0288d1",
        "800": "#0277bd",
        "900": "#01579b",
        A100: "#80d8ff",
        A200: "#40c4ff",
        A400: "#00b0ff",
        A700: "#0091ea",
      },
      indigo: {
        "50": "#e8eaf6",
        "100": "#c5cae9",
        "200": "#9fa8da",
        "300": "#7986cb",
        "400": "#5c6bc0",
        "500": "#3f51b5",
        "600": "#3949ab",
        "700": "#303f9f",
        "800": "#283593",
        "900": "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe",
      },
      deepPurple: {
        "50": "#ede7f6",
        "100": "#d1c4e9",
        "200": "#b39ddb",
        "300": "#9575cd",
        "400": "#7e57c2",
        "500": "#673ab7",
        "600": "#5e35b1",
        "700": "#512da8",
        "800": "#4527a0",
        "900": "#311b92",
        A100: "#b388ff",
        A200: "#7c4dff",
        A400: "#651fff",
        A700: "#6200ea",
      },
      amber: {
        "50": "#fff8e1",
        "100": "#ffecb3",
        "200": "#ffe082",
        "300": "#ffd54f",
        "400": "#ffca28",
        "500": "#ffc107",
        "600": "#ffb300",
        "700": "#ffa000",
        "800": "#ff8f00",
        "900": "#ff6f00",
        A100: "#ffe57f",
        A200: "#ffd740",
        A400: "#ffc400",
        A700: "#ffab00",
      },
      pink: {
        "50": "#fce4ec",
        "100": "#f8bbd0",
        "200": "#f48fb1",
        "300": "#f06292",
        "400": "#ec407a",
        "500": "#e91e63",
        "600": "#d81b60",
        "700": "#c2185b",
        "800": "#ad1457",
        "900": "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162",
      },
      deepOrange: {
        "50": "#fbe9e7",
        "100": "#ffccbc",
        "200": "#ffab91",
        "300": "#ff8a65",
        "400": "#ff7043",
        "500": "#ff5722",
        "600": "#f4511e",
        "700": "#e64a19",
        "800": "#d84315",
        "900": "#bf360c",
        A100: "#ff9e80",
        A200: "#ff6e40",
        A400: "#ff3d00",
        A700: "#dd2c00",
      },
      lightGreen: {
        "50": "#f1f8e9",
        "100": "#dcedc8",
        "200": "#c5e1a5",
        "300": "#aed581",
        "400": "#8bc34a",
        "500": "#8bc34a",
        "600": "#7cb342",
        "700": "#689f38",
        "800": "#558b2f",
        "900": "#33691e",
        A100: "#ccff90",
        A200: "#b2ff59",
        A400: "#76ff03",
        A700: "#64dd17",
      },
      lime: {
        "50": "#f9fbe7",
        "100": "#f0f4c3",
        "200": "#e6ee9c",
        "300": "#dce775",
        "400": "#d4e157",
        "500": "#cddc39",
        "600": "#c0ca33",
        "700": "#afb42b",
        "800": "#9e9d24",
        "900": "#827717",
        A100: "#f4ff81",
        A200: "#eeff41",
        A400: "#c6ff00",
        A700: "#aeea00",
      },
      yellow: {
        "50": "#fffde7",
        "100": "#fff9c4",
        "200": "#fff59d",
        "300": "#fff176",
        "400": "#ffee58",
        "500": "#ffeb3b",
        "600": "#fdd835",
        "700": "#fbc02d",
        "800": "#f9a825",
        "900": "#f57f17",
        A100: "#ffff8d",
        A200: "#ffff00",
        A400: "#ffea00",
        A700: "#ffd600",
      },
      cyan: {
        "50": "#e0f7fa",
        "100": "#b2ebf2",
        "200": "#80deea",
        "300": "#4dd0e1",
        "400": "#26c6da",
        "500": "#00bcd4",
        "600": "#00acc1",
        "700": "#0097a7",
        "800": "#00838f",
        "900": "#006064",
        A100: "#84ffff",
        A200: "#18ffff",
        A400: "#00e5ff",
        A700: "#00b8d4",
      },
      teal: {
        "50": "#e0f2f1",
        "100": "#b2dfdb",
        "200": "#80cbc4",
        "300": "#4db6ac",
        "400": "#26a69a",
        "500": "#009688",
        "600": "#00897b",
        "700": "#00796b",
        "800": "#00695c",
        "900": "#004d40",
        A100: "#a7ffeb",
        A200: "#64ffda",
        A400: "#1de9b6",
        A700: "#00bfa5",
      },
      blueGrey: {
        "50": "#eceff1",
        "100": "#cfd8dc",
        "200": "#b0bec5",
        "300": "#90a4ae",
        "400": "#78909c",
        "500": "#607d8b",
        "600": "#546e7a",
        "700": "#455a64",
        "800": "#37474f",
        "900": "#263238",
        A100: "#cfd8dc",
        A200: "#b0bec5",
        A400: "#78909c",
        A700: "#455a64",
      },
      holloid: {
        "50": "#e3f0fa",
        "100": "#bbdaf3",
        "200": "#92c4eb",
        "300": "#6bade2",
        "400": "#509cdd",
        "500": "#3a8cd8",
        "600": "#347fcb",
        "700": "#2c6eb8",
        "800": "#265da6",
        "900": "#1b4187",
        A700: "#1f8a9f",
        A400: "#35bad5",
        A200: "#81d6e8",
        A100: "#b2e6f2",
      },
    },
    dark: {
      grey: {
        "50": "#fafafa",
        "100": "#f5f5f5",
        "200": "#eeeeee",
        "300": "#e0e0e0",
        "400": "#bdbdbd",
        "500": "#9e9e9e",
        "600": "#757575",
        "700": "#616161",
        "800": "#424242",
        "900": "#212121",
        A100: "#f5f5f5",
        A200: "#eeeeee",
        A400: "#bdbdbd",
        A700: "#616161",
      },
      blue: {
        "50": "#e3f2fd",
        "100": "#bbdefb",
        "200": "#90caf9",
        "300": "#64b5f6",
        "400": "#42a5f5",
        "500": "#2196f3",
        "600": "#1e88e5",
        "700": "#1976d2",
        "800": "#1565c0",
        "900": "#0d47a1",
        A100: "#82b1ff",
        A200: "#448aff",
        A400: "#2979ff",
        A700: "#2962ff",
      },
      purple: {
        "50": "#f3e5f5",
        "100": "#e1bee7",
        "200": "#ce93d8",
        "300": "#ba68c8",
        "400": "#ab47bc",
        "500": "#9c27b0",
        "600": "#8e24aa",
        "700": "#7b1fa2",
        "800": "#6a1b9a",
        "900": "#4a148c",
        A100: "#ea80fc",
        A200: "#e040fb",
        A400: "#d500f9",
        A700: "#aa00ff",
      },
      red: {
        "50": "#feebee",
        "100": "#fecdd2",
        "200": "#ef9a9a",
        "300": "#e57373",
        "400": "#ef5350",
        "500": "#f44336",
        "600": "#e53935",
        "700": "#d32f2f",
        "800": "#c62828",
        "900": "#b71c1c",
        A100: "#ff8a80",
        A200: "#ff5252",
        A400: "#ff1744",
        A700: "#d50000",
      },
      green: {
        "50": "#e8f5e9",
        "100": "#c8e6c9",
        "200": "#a5d6a7",
        "300": "#81c784",
        "400": "#66bb6a",
        "500": "#4caf50",
        "600": "#43a047",
        "700": "#388e3c",
        "800": "#2e7d32",
        "900": "#1b5e20",
        A100: "#b9f6ca",
        A200: "#69f0ae",
        A400: "#00e676",
        A700: "#00c853",
      },
      orange: {
        "50": "#fff3e0",
        "100": "#ffe0b2",
        "200": "#ffcc80",
        "300": "#ffb74d",
        "400": "#ffa726",
        "500": "#ff9800",
        "600": "#fb8c00",
        "700": "#f57c00",
        "800": "#ef6c00",
        "900": "#e65100",
        A100: "#ffd180",
        A200: "#ffab40",
        A400: "#ff9100",
        A700: "#ff6d00",
      },
      lightBlue: {
        "50": "#e1f5fe",
        "100": "#b3e5fc",
        "200": "#81d4fa",
        "300": "#4fc3f7",
        "400": "#29b6f6",
        "500": "#03a9f4",
        "600": "#039be5",
        "700": "#0288d1",
        "800": "#0277bd",
        "900": "#01579b",
        A100: "#80d8ff",
        A200: "#40c4ff",
        A400: "#00b0ff",
        A700: "#0091ea",
      },
      indigo: {
        "50": "#e8eaf6",
        "100": "#c5cae9",
        "200": "#9fa8da",
        "300": "#7986cb",
        "400": "#5c6bc0",
        "500": "#3f51b5",
        "600": "#3949ab",
        "700": "#303f9f",
        "800": "#283593",
        "900": "#1a237e",
        A100: "#8c9eff",
        A200: "#536dfe",
        A400: "#3d5afe",
        A700: "#304ffe",
      },
      deepPurple: {
        "50": "#ede7f6",
        "100": "#d1c4e9",
        "200": "#b39ddb",
        "300": "#9575cd",
        "400": "#7e57c2",
        "500": "#673ab7",
        "600": "#5e35b1",
        "700": "#512da8",
        "800": "#4527a0",
        "900": "#311b92",
        A100: "#b388ff",
        A200: "#7c4dff",
        A400: "#651fff",
        A700: "#6200ea",
      },
      amber: {
        "50": "#fff8e1",
        "100": "#ffecb3",
        "200": "#ffe082",
        "300": "#ffd54f",
        "400": "#ffca28",
        "500": "#ffc107",
        "600": "#ffb300",
        "700": "#ffa000",
        "800": "#ff8f00",
        "900": "#ff6f00",
        A100: "#ffe57f",
        A200: "#ffd740",
        A400: "#ffc400",
        A700: "#ffab00",
      },
      pink: {
        "50": "#fce4ec",
        "100": "#f8bbd0",
        "200": "#f48fb1",
        "300": "#f06292",
        "400": "#ec407a",
        "500": "#e91e63",
        "600": "#d81b60",
        "700": "#c2185b",
        "800": "#ad1457",
        "900": "#880e4f",
        A100: "#ff80ab",
        A200: "#ff4081",
        A400: "#f50057",
        A700: "#c51162",
      },
      deepOrange: {
        "50": "#fbe9e7",
        "100": "#ffccbc",
        "200": "#ffab91",
        "300": "#ff8a65",
        "400": "#ff7043",
        "500": "#ff5722",
        "600": "#f4511e",
        "700": "#e64a19",
        "800": "#d84315",
        "900": "#bf360c",
        A100: "#ff9e80",
        A200: "#ff6e40",
        A400: "#ff3d00",
        A700: "#dd2c00",
      },
      lightGreen: {
        "50": "#f1f8e9",
        "100": "#dcedc8",
        "200": "#c5e1a5",
        "300": "#aed581",
        "400": "#8bc34a",
        "500": "#8bc34a",
        "600": "#7cb342",
        "700": "#689f38",
        "800": "#558b2f",
        "900": "#33691e",
        A100: "#ccff90",
        A200: "#b2ff59",
        A400: "#76ff03",
        A700: "#64dd17",
      },
      lime: {
        "50": "#f9fbe7",
        "100": "#f0f4c3",
        "200": "#e6ee9c",
        "300": "#dce775",
        "400": "#d4e157",
        "500": "#cddc39",
        "600": "#c0ca33",
        "700": "#afb42b",
        "800": "#9e9d24",
        "900": "#827717",
        A100: "#f4ff81",
        A200: "#eeff41",
        A400: "#c6ff00",
        A700: "#aeea00",
      },
      yellow: {
        "50": "#fffde7",
        "100": "#fff9c4",
        "200": "#fff59d",
        "300": "#fff176",
        "400": "#ffee58",
        "500": "#ffeb3b",
        "600": "#fdd835",
        "700": "#fbc02d",
        "800": "#f9a825",
        "900": "#f57f17",
        A100: "#ffff8d",
        A200: "#ffff00",
        A400: "#ffea00",
        A700: "#ffd600",
      },
      cyan: {
        "50": "#e0f7fa",
        "100": "#b2ebf2",
        "200": "#80deea",
        "300": "#4dd0e1",
        "400": "#26c6da",
        "500": "#00bcd4",
        "600": "#00acc1",
        "700": "#0097a7",
        "800": "#00838f",
        "900": "#006064",
        A100: "#84ffff",
        A200: "#18ffff",
        A400: "#00e5ff",
        A700: "#00b8d4",
      },
      teal: {
        "50": "#e0f2f1",
        "100": "#b2dfdb",
        "200": "#80cbc4",
        "300": "#4db6ac",
        "400": "#26a69a",
        "500": "#009688",
        "600": "#00897b",
        "700": "#00796b",
        "800": "#00695c",
        "900": "#004d40",
        A100: "#a7ffeb",
        A200: "#64ffda",
        A400: "#1de9b6",
        A700: "#00bfa5",
      },
      blueGrey: {
        "50": "#eceff1",
        "100": "#cfd8dc",
        "200": "#b0bec5",
        "300": "#90a4ae",
        "400": "#78909c",
        "500": "#607d8b",
        "600": "#546e7a",
        "700": "#455a64",
        "800": "#37474f",
        "900": "#263238",
        A100: "#cfd8dc",
        A200: "#b0bec5",
        A400: "#78909c",
        A700: "#455a64",
      },
      holloid: {
        "50": "#e3f0fa",
        "100": "#bbdaf3",
        "200": "#92c4eb",
        "300": "#6bade2",
        "400": "#509cdd",
        "500": "#3a8cd8",
        "600": "#347fcb",
        "700": "#2c6eb8",
        "800": "#265da6",
        "900": "#1b4187",
        A700: "#1f8a9f",
        A400: "#35bad5",
        A200: "#81d6e8",
        A100: "#b2e6f2",
      },
    },
  },
  breakpoints: {
    xl: 1920,
    lg: 1200,
    md: 900,
    sm: 600,
    xs: 0,
  },
  spacing: {
    "1": 8,
    "2": 16,
    "3": 24,
    "4": 32,
    "5": 40,
    "6": 48,
    "7": 56,
    "8": 64,
    "9": 72,
    "10": 80,
    "11": 88,
    "12": 96,
    "0,5": 4,
    "1,5": 12,
  },
  shape: {
    borderRadius: 8,
    none: 0,
  },
  typography: {
    desktop: {
      fontFamily: "Poppins",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      _fontSize: {
        "1rem": 16,
        "0,75rem": 12,
        "0,875rem": 14,
        "1,25rem": 20,
        "1,5rem": 24,
        "2,125rem": 34,
        "3rem": 48,
        "3,75rem": 60,
        "6rem": 96,
        "0,625rem": 10,
        "0,8125rem": 13,
        "0,9375rem": 15,
        "3,5rem": 56,
        "2,375rem": 38,
        "2rem": 32,
        "1,5625rem": 25,
        "1,125rem": 18,
      },
      fontWeightSemiBold: 600,
      typography: {
        h1: 96,
        h2: 60,
        h3: 48,
        h4: 32,
        h5: 24,
        h6: 20,
        body1: 16,
        body2: 14,
        subtitle1: 16,
        subtitle2: 14,
        overline: 12,
        caption: 12,
      },
    },
    mobile: {
      fontFamily: "Poppins",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      _fontSize: {
        "1rem": 16,
        "0,75rem": 12,
        "0,875rem": 14,
        "1,25rem": 20,
        "1,5rem": 24,
        "2,125rem": 34,
        "3rem": 48,
        "3,75rem": 60,
        "6rem": 96,
        "0,625rem": 10,
        "0,8125rem": 13,
        "0,9375rem": 15,
        "3,5rem": 56,
        "2,375rem": 38,
        "2rem": 32,
        "1,5625rem": 25,
        "1,125rem": 18,
      },
      fontWeightSemiBold: 600,
      typography: {
        h1: 56,
        h2: 38,
        h3: 32,
        h4: 25,
        h5: 20,
        h6: 18,
        body1: 16,
        body2: 14,
        subtitle1: 16,
        subtitle2: 14,
        overline: 12,
        caption: 12,
      },
    },
  },
  metadata: {
    "material-ui": "7.2.0",
    "mui-x": "8.10.0",
  },
};
